/// <reference path="../_all.ts" />

module shoppinglist {
  'use strict';
  
  AvailabilityDirective.$inject = [];
  export function AvailabilityDirective(): ng.IDirective {

      return {
        restrict: 'AE'
        , scope : {
          data : "&"
        }
        , replace: true
        , templateUrl: 'shoppinglist/AvailabilityDirective'
        , link: function (scope: IShoppingListDirectiveDirectiveScope, element: JQuery, attr: ng.IAttributes) {
        }

    };
  }
}